/* eslint-disable import/prefer-default-export */
import '../utils/setup-path';

export { applyBrandingConfig, BRANDING, BRANDING_KEYS } from 'dynamic-branding';

if (process.env.NODE_ENV === 'production') {
    try {
        let dateStr = '';

        if (Number.isNaN(+process.env.REACT_APP_BUILD_DATE_TIME)) {
            dateStr = new Date(
                Date.parse(process.env.REACT_APP_BUILD_DATE_TIME),
            );
        } else {
            dateStr = new Date(Number(process.env.REACT_APP_BUILD_DATE_TIME));
        }
        console.log(`Flexible Admin Branding built on ${dateStr}`);
    } catch {} // eslint-disable-line
}
